import type { ScriptParams } from '$lib/core/script';

/** The first-run drawing's params, set in the Parameters panel. */
export const SAMPLE_PARAMS: ScriptParams = [
  { name: 'width', value: 120, description: 'Plate width' },
  { name: 'height', value: 80, description: 'Plate height' },
  { name: 'margin', value: 15, description: 'Hole inset from each edge' },
  { name: 'relief', value: 15, description: 'Radius of the notch in the top edge' },
];

/** First-run drawing: a parametric plate built from references, so edits keep it attached. */
export const SAMPLE_SCRIPT = `// A parametric plate. Change a value in Parameters and every part follows.
const width = params.width;
const height = params.height;
const margin = params.margin;
const relief = params.relief;
const hole = margin / 2;

// Outline, counter-clockwise from the origin; each edge starts where the last one ended
const bottom = Line.between([0, 0], [width, 0]);
const right = Line.between(bottom.end, [width, height]);
const top = Line.between(right.end, [0, height]);
const left = Line.between(top.end, bottom.start);

// A hole near each corner, where inset guides of its two edges cross
const edges = [bottom, right, top, left];
const insets = edges.map((edge) => edge.offset(margin).guide());
for (let i = 0; i < 4; i += 1) {
  const [center] = insets[i].intersections(insets[(i + 1) % 4]);
  Circle.at(center, hole);
}

// Relief: a notch centered on the top edge, cut where a guide circle crosses it
const middle = top.midPoint();
const [enter, exit] = top.intersections(Circle.at(middle, relief).guide());
const [gap] = top.split(enter, exit);
gap.remove();
Arc.from(middle, exit, enter); // from the left crossing, so it dips into the plate
`;
